function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8 10C8.28333 10 8.521 9.904 8.713 9.712C8.90433 9.52067 9 9.28333 9 9C9 8.71667 8.90433 8.479 8.713 8.287C8.521 8.09567 8.28333 8 8 8C7.71667 8 7.47933 8.09567 7.288 8.287C7.096 8.479 7 8.71667 7 9C7 9.28333 7.096 9.52067 7.288 9.712C7.47933 9.904 7.71667 10 8 10ZM4 18V16L10 15V3.875C10 3.625 9.925 3.4 9.775 3.2C9.625 3 9.43333 2.88333 9.2 2.85L4 2V0L9.5 0.9C10.2333 1.03333 10.8333 1.375 11.3 1.925C11.7667 2.475 12 3.11667 12 3.85V16.65L4 18ZM0 18V16H2V2C2 1.43333 2.196 0.958333 2.588 0.575C2.97933 0.191667 3.45 0 4 0H14C14.5667 0 15.0417 0.191667 15.425 0.575C15.8083 0.958333 16 1.43333 16 2V16H18V18H0ZM4 16H14V2H4V16Z",
  fill: "#008C85"
});
function SvgAsset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset);
export default __webpack_public_path__ + "static/media/asset.ae11b694ef21fef094b2e562fc0aa82f.svg";
export { ForwardRef as ReactComponent };